import type React from 'react';

type InputOptions = { allowNegative?: boolean; decimalPlaces?: number };

export const handleInputNumber = (
	event: React.ChangeEvent<HTMLInputElement>,
	options: InputOptions = {},
) => {
	const { allowNegative = false, decimalPlaces = 2 } = options;
	const input = event.target;
	const valueCurrent = input.value;
	const cursorPosition = input.selectionStart ?? 0;

	let cleanValue = valueCurrent.replace(/[^\d.-]/g, '');

	if (allowNegative) {
		const hasNegativeSign = cleanValue.startsWith('-');
		const hasNumbers = /\d/.test(cleanValue);

		if (hasNegativeSign && hasNumbers) {
			cleanValue = cleanValue.replace(/-/g, (match, offset) =>
				offset === 0 ? match : '',
			);
		}

		if (hasNegativeSign && !hasNumbers) {
			cleanValue = cleanValue.replace(/-/g, (match, offset) =>
				offset === 0 ? match : '',
			);
		}

		if (!hasNegativeSign && hasNumbers) {
			cleanValue = cleanValue.replace(/-/g, '');
		}
	} else {
		cleanValue = cleanValue.replace(/-/g, '');
	}

	if (cleanValue.startsWith('.')) {
		cleanValue = '';
	}

	if (decimalPlaces === 0) {
		cleanValue = cleanValue.replace(/\./g, '');
	}

	const [integerPart, decimalPart] = cleanValue.split('.');

	const limitedDecimalPart = decimalPart?.substring(0, decimalPlaces);

	const formattedValue =
		limitedDecimalPart !== undefined
			? `${integerPart}.${limitedDecimalPart}`
			: integerPart;

	input.value = formattedValue;

	const newCursorPosition =
		cursorPosition + (formattedValue.length - valueCurrent.length);
	input.setSelectionRange(newCursorPosition, newCursorPosition);
};

export default handleInputNumber;
